module.exports = __webpack_public_path__ + "media/images/23february-2ba090295c42ee337c61b410cad6e2aa.jpg";